import ApiClient, { RequestOptions } from "./ApiClient";
import {
    CreateDocumentRequest,
    DocumentListResponse,
    UploadingDocuments,
} from "../model/FileManager";

export default class FileManagerApiClient extends ApiClient {
    public getAllFiles = async (
        tenantId: string,
        limit: number = 50,
        offset: number = 0,
        search: string = ""
    ): Promise<DocumentListResponse> => {
        const params = new URLSearchParams({
            tenantId: tenantId,
            limit: limit.toString(),
            offset: offset.toString(),
            search: search,
        });

        try {
            const response = await this.get(
                `/myFiles/all?${params.toString()}`
            );
            return response;
        } catch (error) {
            console.error("Error parsing response:", error);
            throw new Error("Failed to parse server response");
        }
    };

    public uploadFile = async (fileRequest: CreateDocumentRequest, file: File) => {
        const formData = new FormData();
        formData.append("file", file);

        formData.append(
            "request",
            new Blob([JSON.stringify(fileRequest)], {
                type: "application/json",
            })
        );

        const options: RequestOptions = {
            body: formData,
        };
        return this.post("/myFiles/file", options);
    };

    public getUploadStatus = async (
        tenantId: string
    ): Promise<UploadingDocuments> => {
        return this.get(`/myFiles/uploadStatus?tenantId=${tenantId}`);
    };

    public deleteFile = async (
        fileName: string,
        tenantId: string
    ): Promise<void> => {
        return this.delete(`/myFiles/file/${fileName}?tenantId=${tenantId}`);
    };

    public editFileName = async (
        fileId: string,
        newName: string
    ): Promise<void> => {
        const options: RequestOptions = {
            body: {
                newName,
            },
        };
        return this.patch(`/myFiles/editFileName/${fileId}`, options);
    };

    public getFilePresignedUrl = async (
        fileName: string,
        tenantId: string
    ): Promise<string> => {
        return this.get(`/myFiles/file/${fileName}?tenantId=${tenantId}`);
    };
}
